import { createSlice } from "@reduxjs/toolkit";


interface IThemeState {
  darkTheme: boolean;
}

const initialState: IThemeState = {
  darkTheme: false,
};


export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.darkTheme = !state.darkTheme;
      localStorage.setItem("darkTheme", JSON.stringify(state.darkTheme));
    },
    restoreTheme: (state) => {
      const darkTheme = JSON.parse(localStorage.getItem("darkTheme") || "false");
      state.darkTheme = darkTheme;
    }
  },
});

export const { toggleTheme, restoreTheme } = themeSlice.actions;

export default themeSlice.reducer;